import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
import { images } from '../../../../Constants/ImageUrls';
import { appleStoreLink } from '../../../../Constants/branchUrls';
import { getScreenName } from '../../../../Utils/helper';
import { PlayStorebtn, PlayStoreImages } from './styled';
import { fireEvent } from '../../../../Utils/fireEvent';

export default function PlaystoreButton({
  installLink,
  parent,
  contentStage,
  disableRedirection,
  clickedCtaEvent,
}) {
  const [clickEffect, setClickEffect] = useState(false);

  const playStoreButton = (e) => {
    setClickEffect(1);
    setTimeout(() => {
      setClickEffect(false);
    }, [2000]);
    if (disableRedirection) {
      clickedCtaEvent();
      e.stopPropagation();
    } else {
      fireEvent({
        category: 'clicked_download_app',
        screen_name: getScreenName(),
        name: 'google_play',
        deeplink_value: installLink,
        page_url: window?.location?.href,
        parent: parent ? parent : 'NA',
        stage: contentStage,
      });
    }
    window.location.href = installLink;
  };
  const appleStoreButton = (e) => {
    setClickEffect(2);
    setTimeout(() => {
      setClickEffect(false);
    }, [2000]);
    if (disableRedirection) {
      clickedCtaEvent();
      e.stopPropagation();
    } else {
      fireEvent({
        category: 'clicked_download_app',
        screen_name: getScreenName(),
        name: 'app_store',
        deeplink_value: appleStoreLink,
        page_url: window?.location?.href,
        parent: parent ? parent : 'NA',
        stage: contentStage,
      });
    }
    window.location.href = appleStoreLink;
  };
  return (
    <PlayStorebtn>
      <LazyLoad height={100} once offset={100}>
        <PlayStoreImages
          loading="lazy"
          onClick={playStoreButton}
          src={images.googlePlayIcon}
          alt="google_play_icon"
          width={'90'}
          height={'27'}
          className={clickEffect === 1 ? 'lowOpacity' : null}
        />
      </LazyLoad>

      <LazyLoad height={100} once offset={100}>
        <PlayStoreImages
          loading="lazy"
          onClick={appleStoreButton}
          src={images.appStoreIcon}
          alt="app_store_icon"
          width={90}
          height={27}
          className={clickEffect === 2 ? 'lowOpacity' : null}
        />
      </LazyLoad>
    </PlayStorebtn>
  );
}
